<template>
  <div class="uk-grid-medium uk-child-width-expand@s uk-text-center section3" uk-grid id="special-packages">
    <div class="uk-width-1-1@l uk-width-1-1@m  uk-width-1-1@s">
      <h1 class="uk-text-center uk-text-middle AppTitle Title">
        {{'explore_more'|translate}}
      </h1>
    </div>
    <div v-for="(item, index) in packages" :key="index">
      <h4 class="AppTitle">{{item.title}}</h4>
      <div class="uk-card uk-card-default">
        <div class="uk-card-media-top">
          <img :src="item.url" alt="">
        </div>
        <div class="uk-card-body">
          <p>{{item.description}}</p>
          <div v-if="item.section_id === 'rates_and_offers'">
            <a class="uk-button uk-button-secondary" href="#modal-full-deals" uk-toggle @click="selectedItem = item">
              {{'view_more'|translate}}
            </a>
          </div>
          <div v-else-if="item.section_id === 'food_and_beverage'">
            <a class="uk-button uk-button-secondary" href="#modal-full-foods" uk-toggle @click="selectedItem = item">
              {{'view_more'|translate}}
            </a>
          </div>
          <div v-else-if="item.section_id === 'excursions'">
            <a class="uk-button uk-button-secondary" @click="goToLink('excursions', item.id)">
              {{'view_more'|translate}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--Deals Modal-->
    <div id="modal-full-deals" class="uk-modal-full" uk-modal>
      <div class="uk-modal-dialog" v-if="selectedItem && selectedItem.section_id === 'rates_and_offers'">
        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
        <div class="uk-grid-collapse uk-padding" uk-grid>
          <div class="uk-width-1-1">
            <h1>{{selectedItem.title}}</h1>
            <!--<table class="uk-table uk-table-hover uk-table-divider uk-table-striped">
              <thead>
              <tr>
                <th>Month</th>
                <th>Single (Rs.)</th>
                <th>Double (Rs.)</th>
                <th>Triple (Rs.)</th>
                <th>Quad (Rs.)</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in selectedItem.prices" :key="index">
                <td>{{item.month}}</td>
                <td>{{item.single}}</td>
                <td>{{item.double}}</td>
                <td>{{item.triple}}</td>
                <td>{{item.quad}}</td>
              </tr>
              </tbody>
            </table>-->
          </div>
          <div class="deals-section uk-width-1-1">
            <div class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: slide">
              <div v-for="(item, index) in selectedItem.deals" :key="index">
                <a :href="`${ASSETS_BASE_URL}${item.img_path}`" :data-caption="item.title">
                  <div class="uk-cover-container">
                    <img :src="`${ASSETS_BASE_URL}${item.img_path}`" alt="">
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Foods Modal-->
    <div id="modal-full-foods" class="uk-modal-full" uk-modal>
      <div class="uk-modal-dialog" v-if="selectedItem  && selectedItem.section_id === 'food_and_beverage'">
        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
        <div class="uk-grid-collapse uk-flex-middle" uk-grid>
          <div uk-height-viewport class="uk-width-1-1@l uk-padding">
            <h2>{{selectedItem.title}}</h2>
            <div class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: slide">
              <div v-for="(item, index) in selectedItem.items" :key="index">
                <a :href="`${ASSETS_BASE_URL}${item.img_path}`" :data-caption="item.title">
                  <div class="uk-cover-container">
                    <img :src="`${ASSETS_BASE_URL}${item.img_path}`" alt="">
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '../../router'

export default {
  name: 'PropertySectionFive',
  props: ['packages'],
  data: function () {
    return {
      selectedItem: null
    }
  },
  methods: {
    goToLink: function (link, id) {
      router.push(`${link}#${id}`)
    }
  }
}
</script>

<style scoped>
  .section3 {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  .Title {
    font-family: 'Kaushan Script', cursive !important;
  }

  .deals-section {
    margin-top: 30px;
  }
</style>
